// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_slotted_c_hook/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_slotted_c_hook: ModuleSchema = {
  "id": "core_slotted_c_hook",
  "uniqueId": "B3D_HK01C",
  "createdAt": "2026-10-11T05:00:00Z",
  "updatedAt": "2026-10-11T09:57:51.696Z",
  "label": "Slotted C-Hook",
  "description": "Standalone core geometry module for slotted C-hook swing clasp (CG_HOOK01)",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_HOOK01",
    "c-hook",
    "clasp"
  ],
  "sliders": [
    {
      "key": "innerRadius",
      "label": "Inner Hole Radius (mm)",
      "min": 0.6,
      "max": 4,
      "default": 1.3,
      "step": 0.1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "outerRadius",
      "label": "Outer Ring Radius (mm)",
      "min": 1.2,
      "max": 6,
      "default": 2.4,
      "step": 0.1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "depth",
      "label": "Width / Depth (mm)",
      "min": 1,
      "max": 6,
      "default": 2.4,
      "step": 0.2,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "slotWidth",
      "label": "Slot Opening Width (mm)",
      "min": 0.4,
      "max": 3,
      "default": 1,
      "step": 0.1,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    },
    {
      "key": "edgeRound",
      "label": "Edge Fillet (mm)",
      "min": 0.1,
      "max": 1,
      "default": 0.3,
      "step": 0.05,
      "unit": "mm",
      "integerOnly": false,
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "hook",
      "label": "C-Hook Color",
      "default": "#ffffff",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "c_hook",
      "name": "Slotted C-Hook Solid",
      "parts": [
        {
          "id": "c_hook_part",
          "name": "C-Hook Clasp",
          "groupId": 0,
          "previewQuality": "medium",
          "exportQuality": "high"
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Slotted C-Hook"
    }
  ]
};
